<app-admin-conteiner>
  <section content>
    <app-admin-title *ngIf="breadcrumb"></app-admin-title>
    <ng-container
      *ngIf="!loading; then categoryPage; else categoryLoading"
    ></ng-container>
  </section>
</app-admin-conteiner>

<ng-template #categoryPage>
  <ng-container
    *ngIf="showTabs; then categoryTabs; else categoryForm"
  ></ng-container>
</ng-template>

<ng-template #categoryTabs>
  <app-admin-tabs [titles]="titles">
    <div content1>
      <app-category-form [menuId]="menuId"></app-category-form>
    </div>
    <div content2>
      <app-product-list [categoryId]="categoryId"></app-product-list>
    </div>
  </app-admin-tabs>
</ng-template>

<ng-template #categoryForm>
  <app-category-form [menuId]="menuId"></app-category-form>
</ng-template>

<ng-template #categoryLoading>
  <app-loading message="Cargando..."></app-loading>
</ng-template>
